const {
  WUR_EMBARGO_ACTIONS,
  WUR_VIEW_ACTIONS,
  WUR_OVERALL_ACTIONS,
  WUR_ACTIONS,
  WUR_DATAPLUS_ADVANCED_ACTIONS,
  WUR_ACTIONS_WITHOUT_YEAR,
} = require('./constants');

const wurPermissions = (action, permissions, year) => {
  if (
    action.startsWith('wur:') &&
    permissions.includes('THE_STAFF_ACCESS_ALL_INSTITUTIONS')
  ) {
    return true;
  }

  if (WUR_ACTIONS_WITHOUT_YEAR.some((wurAction) => action === wurAction) &&
  permissions.some((item) =>
    item.includes('DATAPLUS_ADVANCED') ||
    item.includes('DATAPLUS_COMPREHENSIVE') ||
    item.includes('DATAPLUS_RELEASE') ||
    item.includes('DATAPLUS_ESSENTIAL') ||
    item.includes('DATAPLUS_CORE') ||
    item.includes('DATAPLUS_EMBARGO') ||
    item.includes('DATAPLUS_ADVANCED') ||
    item.includes('WUR_REPORTER_INTERIM')
  )) {
    return true;
  }

  if (
    WUR_VIEW_ACTIONS.some((wurAction) => action === wurAction) &&
    permissions.some((item) =>
      [
        `WUR_REPORTER_INTERIM_${year}`,
        `DATAPLUS_RELEASE_${year}`,
        `DATAPLUS_ESSENTIAL_${year}`,
        `DATAPLUS_ADVANCED_${year}`,
        `DATAPLUS_CORE_${year}`,
        `DATAPLUS_COMPREHENSIVE_${year}`,
        `DATAPLUS_EMBARGO_${year}`,
      ].includes(item),
    )
  ) {
    return true;
  }

  if (
    WUR_EMBARGO_ACTIONS.some((wurAction) => action === wurAction) &&
    permissions.some((item) =>
      [
        `DATAPLUS_EMBARGO_${year}`,
      ].includes(item),
    )
  ) {
    return true;
  }

  if (
    WUR_OVERALL_ACTIONS.some((wurAction) => action === wurAction) &&
    permissions.some((item) =>
      [
        `DATAPLUS_RELEASE_${year}`,
        `DATAPLUS_EMBARGO_${year}`,
        `DATAPLUS_ESSENTIAL_${year}`,
        `DATAPLUS_CORE_${year}`,
      ].includes(item),
    )
  ) {
    return true;
  }

  if (
    WUR_ACTIONS.some((wurAction) => action === wurAction) &&
    permissions.includes(`WUR_REPORTER_INTERIM_${year}`)
  ) {
    return true;
  }

  if (
    WUR_DATAPLUS_ADVANCED_ACTIONS.some((wurAction) =>
      action === wurAction,
    ) &&
    permissions.some((item) =>
      [`DATAPLUS_ADVANCED_${year}`, `DATAPLUS_COMPREHENSIVE_${year}`].includes(
        item,
      ),
    )
  ) {
    return true;
  }

  return false;
};

module.exports = {
  wurPermissions,
};
